<nav aria-label="Page navigation example" class="PaginationWrapper">
  <ul class="pagination">
    <li class="page-item " [ngClass]="{'disableDiv': leftArrowDisable}" (click)="first()">
      <a class="page-link" href="javascript:void(0);" aria-label="Previous">
        <span aria-hidden="true"><i class="fa fa-angle-double-left" aria-hidden="true"></i></span>
        <span class="sr-only">Previous</span>
      </a>
    </li>
    <li class="page-item " [ngClass]="{'disableDiv': leftArrowDisable}" (click)="setPage(activePage - 1)"><a class="page-link" href="javascript:void(0);">
        <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
      </a></li>
    <li class="page-item" [ngClass]="{'active': activePage === item}" *ngFor="let item of pages"
      (click)="setPage(item)"><a class="page-link" href="javascript:void(0);">{{item}}</a></li>

    <li class="page-item" [ngClass]="{'disableDiv': rightArrowDisable}"><a class="page-link" (click)="setPage(activePage + 1)" href="javascript:void(0);">
        <span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
      </a></li>
    <li class="page-item" (click)="last()" [ngClass]="{'disableDiv': rightArrowDisable}">
      <a class="page-link" href="javascript:void(0);" aria-label="Next">
        <span aria-hidden="true"><i class="fa fa-angle-double-right" aria-hidden="true"></i></span>
        <span class="sr-only">Next</span>
      </a>
    </li>
  </ul>
</nav>